import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonSearchbar } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { AppEventTypes } from 'src/app/core/models/enums/app-event-types';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IFarmModel } from 'src/app/core/models/interfaces/farm-model';
import { AppEventListenerService } from 'src/app/core/services/app-event-listener.service';
import { LanguageService } from 'src/app/core/services/lang.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'preview-farm-list',
  templateUrl: './preview-farm-list.component.html',
  styleUrls: ['./preview-farm-list.component.scss'],
})
export class PreviewFarmListComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('searchBar') searchBar: IonSearchbar;
  farmList: Array<IFarmModel> = [];
  lastFarmId: number;
  @Input() farmId;
  @Output() onChangeFarm: EventEmitter<IFarmModel> = new EventEmitter();
  selectedFarm: IFarmModel;
  height: number = 40;
  isFilizMode: boolean = false;
  isPending: boolean = false;
  p: number = 1;
  filteredList: Array<IFarmModel> = [];
  deviceStatus: boolean = false;
  showNoResultsMessage: boolean = false;
  searchTerm: string = '';
  sortList: boolean = false;
  sortTypes: string[] = [
    "Alphabetical",
    "Activity Status",
    "Device ID",
    "Recently Added",
  ];
  selectedSortType: string = "Alphabetical";
  selectedSortOrder: 'desc' | 'asc' = "asc";
  tempSelectedSortType: string = "Alphabetical";
  tempSelectedSortOrder: 'desc' | 'asc' = "asc";
  constructor(private router: Router, public storageService: StorageService,
    private farmApiService: FarmApiService,
    private loadingService: LoadingService,
    private cd: ChangeDetectorRef,
    private langService: LanguageService) { }

  ngOnInit(): void {
    this.setFarmList(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && !changes.farmId.firstChange && changes.farmId.previousValue && !this.isChanged) {
      if (!changes.farmId.currentValue) {
        this.setFarmList(true)
      } else {
        this.setFarmList(false)
      }
    }
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.farmList = [];
    this.lastFarmId = null;
  }


  setFarmList(isLoad: boolean) {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(mode => {
      if (mode.IsSuccess) {
        if (mode.Data) {
          this.isFilizMode = true;
          if (!this.isPending)
            this.storageService.get(StorageKeys.FILIZ_DEMO).then(demo => {
              let data = false;
              if (demo.IsSuccess) {
                if (demo.Data) {
                  data = true;
                  this.storageService.demoFiliz = true;
                } else {
                  this.storageService.demoFiliz = false;
                }
                this.setFarmData(data, isLoad);
              }
            });
        } else {
          this.isFilizMode = false;
          if (!this.isPending)
            this.storageService.get(StorageKeys.TRAP_DEMO).then(demo => {
              let data = false;
              if (demo.IsSuccess) {
                if (demo.Data) {
                  data = true;
                  this.storageService.demoTrap = true;
                } else {
                  this.storageService.demoTrap = false;
                }
                this.setFarmData(data, isLoad);
              }
            });
        }
      }
    });

  }

  setFarmData(data: any, isLoad: boolean = true) {
    this.loadingService.showLoading();
    this.isPending = true;
    this.farmApiService.GetAll(isLoad, data, (this.isFilizMode ? 'filiz' : 'trap')).subscribe(e => {
      this.isPending = false;
      this.loadingService.hideLoading();
      if (this.isFilizMode) {
        this.isFilizMode = true;
        this.filteredList = this.farmApiService.filterFarmListWithDeviceType("filiz", e);
        this.farmList = this.farmApiService.filterFarmListWithDeviceType("filiz", e);
        if (Array.isArray(this.farmList) && this.farmList.length > 0) {
          this.farmList.forEach(e => {
            e["DeviceType"] = e.Device.filter(de => !de.Type.includes("trap"))[0].Type;
            // console.log(e["DeviceType"])
            e.Device.forEach(device => {
              this.deviceStatus = device.IsClosed;
            })
          });
          this.lastFarmId = this.storageService.lastFilizFarmId;
          if (!this.lastFarmId) {
            this.storageService.get(StorageKeys.LAST_FILIZ_FARM).then(farm => {
              if (farm.IsSuccess) {
                if (farm.Data) {
                  this.lastFarmId = +farm.Data;
                } else {
                  this.lastFarmId = this.farmList[0].TempFarmAttId;
                  this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.lastFarmId);
                  this.storageService.lastFilizFarmId = this.lastFarmId;
                }
                this.setSelectedFarm();
              }
            });
          } else {
            this.setSelectedFarm();
          }
        } else {
          this.storageService.set(StorageKeys.FILIZ_DEMO, true).then(demo => {
            this.setFarmData(true);
            this.storageService.demoFiliz = true;
          });
        }
      } else {
        this.filteredList = this.farmApiService.filterFarmListWithDeviceType("trap", e);
        this.farmList = this.farmApiService.filterFarmListWithDeviceType("trap", e);
        if (Array.isArray(this.farmList) && this.farmList.length > 0) {
          this.farmList.forEach(e => {
            e["DeviceType"] = e.Device.filter(de => de.Type.includes("trap"))[0].Type;
            e.Device.forEach(device => {
              this.deviceStatus = device.IsClosed;
            })
          });
          this.lastFarmId = this.storageService.lastTrapFarmId;

          if (!this.lastFarmId) {
            this.storageService.get(StorageKeys.LAST_TRAP_FARM).then(trap => {
              if (trap.IsSuccess) {
                if (trap.Data) {
                  this.lastFarmId = +trap.Data;
                } else {
                  this.lastFarmId = this.farmList[0]?.TempFarmAttId;
                  this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.lastFarmId);
                  this.storageService.lastTrapFarmId = this.lastFarmId;
                }
                this.setSelectedFarm();
              }
            });
          } else {
            this.setSelectedFarm();
          }
        } else {
          this.storageService.set(StorageKeys.TRAP_DEMO, true).then(demo => {
            this.setFarmData(true);
            this.storageService.demoTrap = true;
          })
        }
        this.isFilizMode = false;
      }
      this.sortListApply();
      this.sortList = false;
    }, err => {
      this.loadingService.hideLoading();
    });
  }

  getDeviceStatus(farm, type) {
    try {
         if (type.includes("trap")) {
      return farm.Device.filter(e => e.Type == type)[0].IsClosed;
    } else {
      return farm.Device.filter(e => (e.Type == "filiz" || e.Type == "filiz-pro" || e.Type == "filiz-mini"))[0].IsClosed;
    }
    } catch (error) {
      console.log(error)
    }
 
  }

  setSelectedFarm() {
    let farmItem;
    if (this.farmList.length > 0) {
      if (this.farmList.filter(farm => farm.TempFarmAttId == this.lastFarmId).length == 0) {
        farmItem = this.farmList[0];
        this.lastFarmId = this.farmList[0].TempFarmAttId;
        if (this.isFilizMode) {
          this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.lastFarmId);
          this.storageService.lastFilizFarmId = this.lastFarmId;
        } else {
          this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.lastFarmId);
          this.storageService.lastTrapFarmId = this.lastFarmId;
        }
      } else {
        farmItem = this.farmList.filter(farm => farm.TempFarmAttId == this.lastFarmId)[0];
      }
      this.selectedFarm = farmItem;
      this.changeFarm(farmItem, "setselected");
      if (this.farmList.length < 3) {
        this.height = 25 + (this.farmList.length * 10);
      }
    }
  }
  isChanged: boolean = false;
  changeFarm(farm: IFarmModel, type: string) {
    this.isChanged = true;
    this.storageService.openFarmList = false;
    this.selectedFarm = farm;
    this.lastFarmId = farm.TempFarmAttId;
    if (farm.Device) {
      if (this.isFilizMode) {
        this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.lastFarmId);
        this.storageService.lastFilizFarmId = this.lastFarmId;
      } else {
        this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.lastFarmId);
        this.storageService.lastTrapFarmId = this.lastFarmId;
      }
      this.deviceStatus = this.selectedFarm.Device.filter(e => {
        return (!this.isFilizMode ? (e.Type.includes("trap")) : (!e.Type.includes("trap")))
      })[0].IsClosed
    }
    FarmApiService.SelectedFarm = farm;
    this.onChangeFarm.emit(farm);
    setTimeout(() => {
      this.isChanged = false;
    }, 10);

  }

  viewButton(farm: IFarmModel) {
    this.router.navigate(["/common/detail"], {
      queryParams: {
        sensorType: farm.DeviceType,
        farmId: farm.TempFarmAttId
      }
    });
  }

  clearSearch(searchBar) {
    searchBar.value = '';
    this.searchTerm = null;
    this.showNoResultsMessage = false;
    this.filteredList = this.farmList;

  }

  openAddField() {
    this.router.navigate(["/common/pair-device"]);
  }

  onSearchChange(ev) {
    if (!(ev?.detail?.value == null || ev?.detail?.value == undefined)) {
      this.p = 1;
      let query = ev.detail.value.toLowerCase();
      this.searchTerm = query;
      this.filteredList = this.farmList.filter(t =>
        t.FarmName.toLowerCase().includes(query) ||
        t.CropName.toLowerCase().includes(query) ||
        t.Device.some(device => device.SensorId.includes(query))
      );
      this.showNoResultsMessage = this.filteredList.length === 0;
      if (query === '') {
        this.sortListApply();
        this.sortList = false;
      }
    } else {
      this.filteredList = this.farmList;
      this.showNoResultsMessage = false;
    }
  }

  openSortField() {
    this.tempSelectedSortOrder = this.selectedSortOrder;
    this.tempSelectedSortType = this.selectedSortType;
    this.sortList = !this.sortList;
    this.showNoResultsMessage = false;
    this.filteredList = this.farmList;
  }

  selectSortType(sortType: string) {
    if (sortType === this.tempSelectedSortType) {
      if (this.tempSelectedSortOrder === 'asc') {
        this.tempSelectedSortOrder = 'desc';
      } else {
        this.tempSelectedSortOrder = 'asc';
      }
    }
    this.tempSelectedSortType = sortType;
  }

  sortByField(fieldName: string, sortOrder: 'asc' | 'desc') {
    const lang = this.langService.getcurrentLanguage();
    const list = this.filteredList.sort(function (a, b) {
      const valueA = a[fieldName].toLocaleLowerCase();
      const valueB = b[fieldName].toLocaleLowerCase();
      return valueA.localeCompare(valueB, lang.code);
    });

    return sortOrder === 'asc' ? list : list.reverse()
  }

  sortByRecentAddedDate(fieldName: string, sortOrder: 'asc' | 'desc') {
    return this.filteredList.sort(function (a, b) {
      var createdDataDateA: any = new Date(a[fieldName]);
      var createdDataDateB: any = new Date(b[fieldName]);
      if (sortOrder === 'asc') {
        return createdDataDateA - createdDataDateB;
      } else if (sortOrder === 'desc') {
        return createdDataDateB - createdDataDateA;
      }
    });
  }

  sortByDeviceLastDataDate(fieldName: string, sortOrder: 'asc' | 'desc') {
    return this.filteredList.sort(function (a, b) {
      var lastDataDateA: any = new Date(a.Device[0][fieldName]);
      var lastDataDateB: any = new Date(b.Device[0][fieldName]);
      if (sortOrder === 'asc') {
        return lastDataDateA - lastDataDateB;
      } else if (sortOrder === 'desc') {
        return lastDataDateB - lastDataDateA;
      }
    });
  }

  sortByDeviceId(fieldName: string, sortOrder: 'asc' | 'desc') {
    return this.filteredList.sort(function (a, b) {
      var deviceA = a.Device[0][fieldName];
      var deviceB = b.Device[0][fieldName];
      if (sortOrder === 'asc') {
        return deviceA - deviceB;
      } else if (sortOrder === 'desc') {
        return deviceB - deviceA;
      }
    });
  }

  sortListApply() {
    this.selectedSortOrder = this.tempSelectedSortOrder;
    this.selectedSortType = this.tempSelectedSortType;
    if (this.selectedSortType === 'Alphabetical') {
      this.filteredList = this.sortByField('FarmName', this.selectedSortOrder);
    }
    if (this.selectedSortType === "Recently Added") {
      this.filteredList = this.sortByRecentAddedDate('CreatedOn', this.selectedSortOrder);
    }
    if (this.selectedSortType === "Activity Status") {
      this.filteredList = this.sortByDeviceLastDataDate('LastDataDate', this.selectedSortOrder);
    }
    if (this.selectedSortType === "Device ID") {
      this.sortByDeviceId("SensorId", this.selectedSortOrder)
    }
    this.sortList = !this.sortList;
  }


  getTranslationKey(sortType: string): string {
    switch (sortType) {
      case "Alphabetical":
        return "alphabetical";
      case "Activity Status":
        return "activityStatus";
      case "Device ID":
        return "deviceID";
      case "Recently Added":
        return "recentlyAdded";
      default:
        return "";
    }
  }

  getDeviceFromType(deviceList: Array<any>, type: string){
    return deviceList.find(t => t.Type == type)
  }

}
